'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = undefined;

var _MenuList$childContex;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _MenuListStyled = require('./styles/MenuListStyled');

var _TitleStyled = require('./styles/TitleStyled');

var _broadcastsConstants = require('../broadcastsConstants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  /**
   * List title
   */
  title: _propTypes2.default.string,

  /**
  * Simulate item offset for nested trees
  */
  nestingLevel: _propTypes2.default.number,

  /**
   * Adds border to visually separate two lists
   */
  bordered: _propTypes2.default.bool,

  /**
   * Define item colorScheme
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Set to 'light' for using menu on dark background
   */
  inline: _propTypes2.default.bool
};
var defaultProps = {
  title: '',
  nestingLevel: 0,
  colorScheme: 'dark',
  bordered: false,
  inline: false
};

var MenuList = exports.MenuList = function (_Component) {
  _inherits(MenuList, _Component);

  function MenuList(props) {
    _classCallCheck(this, MenuList);

    var _this = _possibleConstructorReturn(this, (MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call(this, props));

    _this._broadcast = (0, _reactackleCore.createBroadcast)({
      inline: _this.props.inline,
      colorScheme: _this.props.colorScheme,
      nestingLevel: _this.props.nestingLevel
    });
    return _this;
  }

  _createClass(MenuList, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _extends2;

      return _extends({}, this.context, (_extends2 = {}, _defineProperty(_extends2, _broadcastsConstants.MENU_BROADCAST, this._broadcast.subscribe), _defineProperty(_extends2, _broadcastsConstants.MENU_GROUP_BROADCAST, this._broadcast.subscribe), _extends2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          bordered = _props.bordered,
          inline = _props.inline;

      var titleBox = title && _react2.default.createElement(_TitleStyled.TitleStyled, null, title);

      return _react2.default.createElement(_MenuListStyled.MenuListStyled, {
        bordered: bordered,
        inline: inline
      }, titleBox, children);
    }
  }]);

  return MenuList;
}(_react.Component);

MenuList.propTypes = propTypes;
MenuList.defaultProps = defaultProps;
MenuList.displayName = 'MenuList';
MenuList.childContextTypes = (_MenuList$childContex = {}, _defineProperty(_MenuList$childContex, _broadcastsConstants.MENU_BROADCAST, _propTypes2.default.func.isRequired), _defineProperty(_MenuList$childContex, _broadcastsConstants.MENU_GROUP_BROADCAST, _propTypes2.default.func.isRequired), _MenuList$childContex);
var MenuListWithMenuProps = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_BROADCAST)(function (_ref) {
  var externalProps = _ref.externalProps,
      props = _objectWithoutProperties(_ref, ['externalProps']);

  return _react2.default.createElement(MenuList, _extends({}, externalProps, props));
});
exports.default = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_GROUP_BROADCAST)(function (_ref2) {
  var externalProps = _ref2.externalProps,
      props = _objectWithoutProperties(_ref2, ['externalProps']);

  return _react2.default.createElement(MenuListWithMenuProps, _extends({}, externalProps, props));
});